export default class CreditCardBasicInfo {
  constructor(data = {}) {
    this.cardType = data.cardType;
    this.expirationMonth = data.expirationMonth;
    this.expirationYear = data.expirationYear;
  }
}
